Object.defineProperty(exports, "__esModule", {
  value: true
});

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$inverse = _ref.inverse,
      inverse = _ref$inverse === undefined ? false : _ref$inverse;

  return {
    // Removes weird bonus padding from button in Firefox.
    '::-moz-focus-inner': {
      border: 0,
      padding: 0,
      margin: 0
    },
    ':focus::-moz-focus-inner': {
      border: '1px dotted ' + String(inverse ? _color2['default'].white : _color2['default'].black)
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/removeFirefoxButtonPadding.js
// module id = 93
// module chunks = 168707334958949